import type {_ActionsTree} from 'pinia';
import type {DialogStoreState, DialogStoreStateOption} from "@/store/dialog/state";

export interface DialogStoreActions extends _ActionsTree {
    open: (options: DialogStoreStateOption) => void;
    close: () => void;
    addMultiOption: (options: DialogStoreStateOption) => void;
    deleteMultiOption: (options: DialogStoreStateOption) => void;
    clearMultiOption: () => void;
}

export const actions: DialogStoreActions | DialogStoreState = {
    open(options: DialogStoreStateOption): void {
        const that: DialogStoreState = this as DialogStoreState;
        that.show = true;
        that.options = options;
    },

    close(): void {
        this.show = false;
    },

    addMultiOption(options: DialogStoreStateOption): void {
        const that: DialogStoreState = this as DialogStoreState;
        that.multiOption.push(options)
    },

    deleteMultiOption(options: DialogStoreStateOption): void {
        const that: DialogStoreState = this as DialogStoreState;
        that.multiOption = that.multiOption.filter(option => option.type !== options.type)
    },

    clearMultiOption(): void {
        const that: DialogStoreState = this as DialogStoreState;
        that.multiOption = [];
    }
};
